import React from 'react'
import MenuIcon from '@mui/icons-material/Menu'
import {
  AppBar,
  Box,
  Button,
  Container,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Typography, useMediaQuery, useTheme,
} from '@mui/material'
import { Link } from 'react-router-dom'
import { makeStyles } from '@mui/styles'
import Logo from '../Icons/Logo'
import { Theme } from '@mui/material/styles'

const Header: React.FC = () => {
  const theme: Theme = useTheme()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))

  const useStyles = makeStyles(() => ({
    link: {
      color: downMd ? theme.palette.primary.main : '#ffffff',
      fontWeight: 'bold',
      textDecoration: 'underline #ffffff',
      '&:hover': {
        color: downMd ? theme.palette.primary.main : '#ba3e5c',
        textDecoration: 'underline #931633',
      },
    },
  }))

  const classes = useStyles()
  const pages = [
    { name: 'Startseite', link: '/' },
    { name: 'Unser Tag', link: '/day' },
    { name: 'Feedback', link: '/bewertungen' },
  ]
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null,
  )

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget)
  }

  const handleCloseNavMenu = () => {
    setAnchorElNav(null)
  }
  return (
    <AppBar position='static'>
      <Container maxWidth='xl'>
        <Toolbar disableGutters>
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size='large'
              aria-label='account of current user'
              aria-controls='menu-appbar'
              aria-haspopup='true'
              onClick={handleOpenNavMenu}
              color='inherit'
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id='menu-appbar'
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              {pages.map((page, idx) => (
                <MenuItem key={idx} onClick={handleCloseNavMenu}>
                  <Typography textAlign='center'>
                    <Link to={page.link} className={classes.link}>
                      {page.name}
                    </Link>
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {pages.map((page, idx) => (
              <Button
                key={idx}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: '#ffffff', display: 'block' }}
              >
                <Link to={page.link} className={classes.link}>
                  {page.name}
                </Link>
              </Button>
            ))}
          </Box>

          <Typography
            variant='h6'
            noWrap
            component='a'
            href='/'
            sx={{
              mr: 2,
              display: 'flex',
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <a href='https://www.girls-day.de/' target='_blank'> <Logo /> </a>
          </Typography>
          <Typography
            variant='h6'
            noWrap
            component='a'
            href='/'
            sx={{
              mr: 2,
              display: 'flex',
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            <a href='https://www.3m5.de/' target='_blank'>
              <img style={{width: '70px'}} src={'./images/logo3m5.png'} />
            </a>
          </Typography>
        </Toolbar>
      </Container>
    </AppBar>
  )
}
export default Header
